const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getProcessNavigationRoot = (wrapper) => (
    wrapper.closest('.process-sec') || wrapper
);

export const getProcessSideOffset = (viewportWidth) => {
    return viewportWidth <= 640 ? 0.42 : 0.28;
};

export const getProcessPathRatio = (progress, sideOffset) => (
    clamp(0.5 + progress * sideOffset, 0, 1)
);

export const getProcessPathOverflow = (progress, sideOffset) => {
    const ratio = 0.5 + progress * sideOffset;

    return ratio - clamp(ratio, 0, 1);
};

export const getProcessItemScale = (progress) => (
    1 - Math.min(Math.abs(progress), 1) * 0.25
);

export const getProcessStateDuration = (duration, isDragging = false, isLoopFixing = false) => {
    if (isLoopFixing) {
        return 0;
    }

    if (isDragging) {
        return 200;
    }

    return Math.min(Math.max(duration, 0), 200);
};

export const getProcessOpacityDelay = (isVisible, wasVisible, stateDuration, isDragging = false) => (
    isVisible && !wasVisible && !isDragging ? stateDuration : 0
);

export const isProcessSlideActive = (slideRealIndex, activeRealIndex, progress) => (
    slideRealIndex === activeRealIndex && Math.abs(progress) < 0.5
);
